import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { IconStyle } from './iconPicker';

interface IconStyleControlsProps {
  value: IconStyle;
  onChange: (patch: Partial<IconStyle>) => void;
}

export default function IconStyleControls({ value, onChange }: IconStyleControlsProps) {
  const { t } = useTranslation();

  const handle =
    (property: keyof IconStyle) => (event: { target: { value: string } }) => {
      onChange({ [property]: event.target.value });
    };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        {t('editor.iconSelector.style')}
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6, sm: 3 }}>
          <FormControl fullWidth size="small">
            <InputLabel>{t('editor.iconSelector.size')}</InputLabel>
            <Select value={value.size} onChange={handle('size')} label={t('editor.iconSelector.size')}>
              <MenuItem value="small">{t('editor.iconSelector.sizes.small')}</MenuItem>
              <MenuItem value="medium">{t('editor.iconSelector.sizes.medium')}</MenuItem>
              <MenuItem value="large">{t('editor.iconSelector.sizes.large')}</MenuItem>
              <MenuItem value="xl">{t('editor.iconSelector.sizes.xl')}</MenuItem>
              <MenuItem value="xxl">{t('editor.iconSelector.sizes.xxl')}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 6, sm: 3 }}>
          <FormControl fullWidth size="small">
            <InputLabel>{t('editor.iconSelector.color')}</InputLabel>
            <Select value={value.color} onChange={handle('color')} label={t('editor.iconSelector.color')}>
              <MenuItem value="primary">{t('editor.iconSelector.colors.primary')}</MenuItem>
              <MenuItem value="secondary">{t('editor.iconSelector.colors.secondary')}</MenuItem>
              <MenuItem value="success">{t('editor.iconSelector.colors.success')}</MenuItem>
              <MenuItem value="warning">{t('editor.iconSelector.colors.warning')}</MenuItem>
              <MenuItem value="error">{t('editor.iconSelector.colors.error')}</MenuItem>
              <MenuItem value="info">{t('editor.iconSelector.colors.info')}</MenuItem>
              <MenuItem value="light">{t('editor.iconSelector.colors.light')}</MenuItem>
              <MenuItem value="dark">{t('editor.iconSelector.colors.dark')}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 6, sm: 3 }}>
          <FormControl fullWidth size="small">
            <InputLabel>{t('editor.iconSelector.alignment')}</InputLabel>
            <Select
              value={value.alignment}
              onChange={handle('alignment')}
              label={t('editor.iconSelector.alignment')}
            >
              <MenuItem value="inline">{t('editor.iconSelector.alignments.inline')}</MenuItem>
              <MenuItem value="left">{t('editor.iconSelector.alignments.left')}</MenuItem>
              <MenuItem value="center">{t('editor.iconSelector.alignments.center')}</MenuItem>
              <MenuItem value="right">{t('editor.iconSelector.alignments.right')}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 6, sm: 3 }}>
          <FormControl fullWidth size="small">
            <InputLabel>{t('editor.iconSelector.margin')}</InputLabel>
            <Select value={value.margin} onChange={handle('margin')} label={t('editor.iconSelector.margin')}>
              <MenuItem value="none">{t('editor.iconSelector.margins.none')}</MenuItem>
              <MenuItem value="small">{t('editor.iconSelector.margins.small')}</MenuItem>
              <MenuItem value="medium">{t('editor.iconSelector.margins.medium')}</MenuItem>
              <MenuItem value="large">{t('editor.iconSelector.margins.large')}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
}
